import { render, staticRenderFns } from "./TourPassenger.vue?vue&type=template&id=483feb34&scoped=true"
import script from "./TourPassenger.vue?vue&type=script&lang=js"
export * from "./TourPassenger.vue?vue&type=script&lang=js"
import style0 from "./TourPassenger.vue?vue&type=style&index=0&id=483feb34&prod&lang=scss"
import style1 from "./TourPassenger.vue?vue&type=style&index=1&id=483feb34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483feb34",
  null
  
)

export default component.exports